import React, { ReactNode } from "react";
import {
  Box,
  ButtonBase,
  styled,
  SxProps,
  Theme,
  Typography,
} from "@mui/material";
import ArrowRightCircleIcon from "@icons/myicons/arrow-right-circle.svg?react";

const optionRowSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(4),
  width: "100%",
  textAlign: "left",
  padding: theme.spacing(5, 4),
  borderRadius: "8px",
  border: `1px solid ${theme.palette.border.secondary}`,
  transition: "border-color 0.2s, background-color 0.2s",
  "&:hover": {
    borderColor: theme.palette.border.active,
    backgroundColor: theme.palette.background.subtle,
  },
});

const OptionIconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "34px",
  height: "34px",
  borderRadius: "8px",
  backgroundColor: theme.palette.background.infoLight,
  color: theme.palette.primary.main,
}));

type Props = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  onClick?: () => void;
  href?: string;
};

export const ProceedOption = ({
  icon,
  title,
  subtitle,
  onClick,
  href,
}: Props) => {
  const content = (
    <>
      <OptionIconBox>{icon}</OptionIconBox>
      <Box flex={1}>
        <Typography variant="body1" color="textPrimary">
          {title}
        </Typography>
        <Typography variant="body3" color="textSecondary">
          {subtitle}
        </Typography>
      </Box>
      <Box display="flex" color="icon.secondary">
        <ArrowRightCircleIcon width="28px" height="28px" />
      </Box>
    </>
  );

  if (href) {
    return (
      <ButtonBase
        sx={optionRowSx}
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {content}
      </ButtonBase>
    );
  }

  return (
    <ButtonBase sx={optionRowSx} onClick={onClick}>
      {content}
    </ButtonBase>
  );
};
